exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-43712a04] {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  font-size: 14px;\n  gap: 8px;\n}\nbutton .icon-wrapper[data-v-43712a04] {\n  border-radius: 9999px;\n  padding: 8px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n}\nbutton .icon-wrapper i[data-v-43712a04] {\n  margin: auto;\n  font-size: 13px;\n}\n.border[data-v-43712a04] {\n  border: 1px solid;\n}", ""]);

// exports
